__turbopack_context__.v({
  "column": "ZyIeoG_column",
  "columnCount": "ZyIeoG_columnCount",
  "columnHeader": "ZyIeoG_columnHeader",
  "columnIcon": "ZyIeoG_columnIcon",
  "columnTitle": "ZyIeoG_columnTitle",
  "compareGrid": "ZyIeoG_compareGrid",
  "container": "ZyIeoG_container",
  "critical": "ZyIeoG_critical",
  "divider": "ZyIeoG_divider",
  "emptyState": "ZyIeoG_emptyState",
  "findingItem": "ZyIeoG_findingItem",
  "findingTitle": "ZyIeoG_findingTitle",
  "findingsList": "ZyIeoG_findingsList",
  "high": "ZyIeoG_high",
  "low": "ZyIeoG_low",
  "medium": "ZyIeoG_medium",
  "mobileWrapper": "ZyIeoG_mobileWrapper",
  "screenshot": "ZyIeoG_screenshot",
  "screenshotColumn": "ZyIeoG_screenshotColumn",
  "screenshotWrapper": "ZyIeoG_screenshotWrapper",
  "screenshotsRow": "ZyIeoG_screenshotsRow",
  "severityIndicator": "ZyIeoG_severityIndicator",
  "severityPill": "ZyIeoG_severityPill",
  "severitySummary": "ZyIeoG_severitySummary",
});
